module.exports = __webpack_public_path__ + "static/media/vexxo.b26b37e6.png";